import { inject, bindable, IEventAggregator } from "aurelia";
import { getLogger } from "../../common/logging";
import { LocaleChanged } from "../../messages/locale-changed";
let log = getLogger("pop-over");

@inject(Element, IEventAggregator)
export class PopOverCustomAttribute {
  @bindable value;

  constructor(element, ea) {
    this.element = element;
    this.ea = ea;
    this.opts = {
      trigger: "hover",
      placement: "top",
      html: true,
    };
  }

  attached() {
    this.subscription = this.ea.subscribe(LocaleChanged, (m) => {
      this.createPopover();
    });
  }

  detaching() {
    this.subscription.dispose();
    // The popover is appended to <body>, outside the element. Disposing removes it there too, so a
    // popover open while the page is left does not stay on top of the next page.
    $(this.element).popover("dispose");
  }

  binding() {
    this.element.style.cursor = "pointer";
    this.createPopover();
  }

  createPopover() {
    $(this.element).popover("dispose");

    this.opts.content = this.value ?? "";
    let attrs = this.element.attributes;

    if (attrs["data-placement"])
      this.opts.placement = attrs["data-placement"].value;
    if (attrs["data-trigger"]) this.opts.trigger = attrs["data-trigger"].value;

    $(this.element).popover(this.opts);

    if (attrs["data-hide-on-click"]) {
      this.element.addEventListener("click", () => {
        $(this.element).popover("hide");
      });
    }
  }
}
